export default "__VITE_ASSET__CAWHvoI___"